export default __webpack_public_path__ + "8dec443029b185aaec92714bbab3fbb7.jpg";